import { render, staticRenderFns } from "./PainelConfirmModal.vue?vue&type=template&id=6b2eec08&scoped=true"
import script from "./PainelConfirmModal.vue?vue&type=script&lang=js"
export * from "./PainelConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./PainelConfirmModal.vue?vue&type=style&index=0&id=6b2eec08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2eec08",
  null
  
)

export default component.exports